import React from 'react';
import { v4 as uuid } from 'uuid';

import { TooltipPortal } from '~components';
import Icon, { faTriangleExclamation, IconProp } from '~components/icon';

interface ComponentProps {
  id?: string;
  label?: string;
  showAlert?: boolean;
  color?: string;
  tooltip?: string;
  className?: string;
  icon?: IconProp;
}

const AlertBadge: React.FC<ComponentProps> = ({
  id,
  label,
  showAlert = false,
  color = 'orange',
  tooltip,
  className = '',
  icon = faTriangleExclamation,
}) => {
  const iconId = `${id || uuid()}_alert_icon`;

  return (
    <span className={`inline-flex items-center ${className}`}>
      {showAlert && (
        <span className="me-2">
          <Icon id={iconId} name="alert" icon={icon} color={color} />
          {tooltip && <TooltipPortal targetId={iconId} content={tooltip} />}
        </span>
      )}
      {label && <span>{label}</span>}
    </span>
  );
};

export default AlertBadge;
